module.exports = __webpack_public_path__ + "img/energy-shield-equipment.990e444b.png";